import api from "@/frontend/api";

export default {
    get: (params, id = null) => api.get('works' + (id ? '/' + id : ''), params),
    getUnion: (params) => api.get('works/union', params),
    getRand: (params) => api.get('works/random', params),
    getYears: () => api.get('works/years'),
    getSimilarAuthor: (authorId, params) => api.get('works/similar-author/' + authorId, params),
    requestBuy: (id, params) => api.post('works/request-buy/' + id, params),
    requestPrice: (id, params) => api.post('works/request-price/' + id, params),
}